import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes/index";
import {
  savePlanSuccess, savePlanFailure,
  updatePlanSuccess, updatePlanFailure,
  deletePlanSuccess, deletePlanFailure,
  readPlanSuccess, readPlanFailure,
  saveDayPlanSuccess, saveDayPlanFailure,
  updateDayPlanSuccess, updateDayPlanFailure,
  deleteDayPlanSuccess, deleteDayPlanFailure,
  readDayPlanSuccess, readDayPlanFailure,
  saveDayPlanDetailSuccess, saveDayPlanDetailFailure,
  updateDayPlanDetailSuccess, updateDayPlanDetailFailure,
  deleteDayPlanDetailSuccess, deleteDayPlanDetailFailure,
  readPlanCategoriesSuccess, readPlanCategoriesFailure,
  savePlanCategorySuccess, savePlanCategoryFailure,
  readTWGPlansSuccess, readTWGPlansFailure,
  savePlanLinkSuccess, savePlanLinkFailure,
  updatePlanLinkSuccess, updatePlanLinkFailure,
  deletePlanLinkSuccess, deletePlanLinkFailure,
  readPlanLinkSuccess, readPlanLinkFailure

} from "./planActions";

import {
  savePlan, updatePlan, deletePlan, readPlan,
  saveDayPlan, updateDayPlan, deleteDayPlan, readDayPlan,  saveDayPlanDetail, updateDayPlanDetail,deleteDayPlanDetail,
  readPlanCategories,
  savePlanCategory,
  readTWGPlans,
  savePlanLink, updatePlanLink, deletePlanLink, readPlanLink

} from "./planAPI";

// ✅ Plan Sagas
function* savePlanSaga(action) {
  try {
    const response = yield call(savePlan, action.payload);

    const savedPlan = { ...action.payload, ...response };
    yield put(savePlanSuccess(savedPlan));

    if (action.callback) action.callback(savedPlan);
  } catch (error) {
    yield put(savePlanFailure(error));
  }
}


function* updatePlanSaga(action) {
  try {
    const res = yield call(updatePlan, action.payload);
        if (res?.type === 1) {
      yield put(updatePlanSuccess(res.data));
      toast.success(res.message || "Plan updated successfully!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Update failed");
  } catch (error) {
    yield put(updatePlanFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

function* deletePlanSaga(action) {
  try {
    const res = yield call(deletePlan, action.payload);
    if (res?.type === 1) {
      yield put(deletePlanSuccess(action.payload));
      toast.success(res.message || "Plan deleted successfully!");
      if (action.callback) action.callback({ type: 1, _id: action.payload._id });
    } else throw new Error(res?.error || "Delete failed");
  } catch (error) {
    yield put(deletePlanFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

function* readPlanSaga(action) {
  try {
    const res = yield call(readPlan, action.payload);
    if (res?.type === 1) {
      yield put(readPlanSuccess(res.data));
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Read failed");
  } catch (error) {
    yield put(readPlanFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}



function* saveDayPlanSaga(action) {
  try {
    const res = yield call(saveDayPlan, action.payload);

    if (res?.type === 1) {
      // Extract dayplanObjId from the response
      const dayplanObjId = res.dayplanObjId || res._id || (res.data && (res.data.dayplanObjId || res.data._id));

      // Create a response object with the dayplanObjId
      const responseWithId = {
        ...res,
        dayplanObjId: dayplanObjId,
        _id: dayplanObjId || res._id
      };

      yield put(saveDayPlanSuccess(responseWithId));

      if (action.callback) {
                action.callback(responseWithId);
      }
    } else {
      throw new Error(res?.error || "Save failed");
    }
  } catch (error) {
    yield put(saveDayPlanFailure(error.message));

    if (action.callback) {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* updateDayPlanSaga(action) {
  try {
    const res = yield call(updateDayPlan, action.payload);
    if (res?.type === 1) {
      yield put(updateDayPlanSuccess(res.data));
      toast.success(res.message || "Day plan updated successfully!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Update failed");
  } catch (error) {
    yield put(updateDayPlanFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

function* deleteDayPlanSaga(action) {
  try {
    const res = yield call(deleteDayPlan, action.payload);
    if (res?.type === 1) {
      yield put(deleteDayPlanSuccess(action.payload));
      toast.success(res.message || "Day plan deleted successfully!");
      if (action.callback) action.callback({ type: 1, _id: action.payload._id });
    } else throw new Error(res?.error || "Delete failed");
  } catch (error) {
    yield put(deleteDayPlanFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

function* readDayPlanSaga(action) {
  try {
    const res = yield call(readDayPlan, action.payload);
    if (res?.type === 1) {
      yield put(readDayPlanSuccess(res.data));
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Read failed");
  } catch (error) {
    yield put(readDayPlanFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}
function* saveDayPlanDetailSaga(action) {

  try {
    const res = yield call(saveDayPlanDetail, action.payload);

    if (res?.type === 1) {
      yield put(saveDayPlanDetailSuccess(res.data));
      toast.success(res.message || "Day plan detail saved successfully!");

      if (action.callback) {
                action.callback({ type: 1, data: res.data });
      }
    } else {
            throw new Error(res?.error || "Save detail failed");
    }
  } catch (error) {
        yield put(saveDayPlanDetailFailure(error.message));
    toast.error(error.message);

    if (action.callback) {
            action.callback({ type: 0, error: error.message });
    }
  }
}

function* updateDayPlanDetailSaga(action) {
  try {
    const res = yield call(updateDayPlanDetail, action.payload);
    if (res?.type === 1) {
      yield put(updateDayPlanDetailSuccess(res.data));
      toast.success(res.message || "Day plan detail updated successfully!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Update detail failed");
  } catch (error) {
    yield put(updateDayPlanDetailFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}
function* deleteDayPlanDetailSaga(action) {
  try {
    const res = yield call(deleteDayPlanDetail, action.payload);
    if (res?.type === 1) {
      yield put(deleteDayPlanDetailSuccess(action.payload));
      toast.success(res.message || "Day plan detail deleted successfully!");
      if (action.callback) action.callback({ type: 1, data: action.payload });
    } else throw new Error(res?.error || "Delete detail failed");
  } catch (error) {
    yield put(deleteDayPlanDetailFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

function* readPlanCategoriesSaga(action) {
  try {
    const res = yield call(readPlanCategories, action.payload);
    if (res?.type === 1) {
      yield put(readPlanCategoriesSuccess(res.data));
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Read categories failed");
  } catch (error) {
    yield put(readPlanCategoriesFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

function* savePlanCategorySaga(action) {
  try {
    const res = yield call(savePlanCategory, action.payload);
    if (res?.type === 1) {
      yield put(savePlanCategorySuccess(res.data));
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Save category failed");
  } catch (error) {
    yield put(savePlanCategoryFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

function* readTWGPlansSaga(action) {
  try {
    const res = yield call(readTWGPlans, action.payload);
    if (res?.type === 1) {
      yield put(readTWGPlansSuccess(res.data));
      if (action.callback) action.callback({ type: 1, data: res.data, total: res.total || res.data?.length || 0 });
    } else throw new Error(res?.message || res?.error || "Read TWG plans failed");
  } catch (error) {
    yield put(readTWGPlansFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// Plan Link Sagas
function* savePlanLinkSaga(action) {
  try {
    const res = yield call(savePlanLink, action.payload);
    if (res?.type === 1) {
      yield put(savePlanLinkSuccess(res.data));
      toast.success(res.message || "Plan linked successfully!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Link failed");
  } catch (error) {
    yield put(savePlanLinkFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

function* updatePlanLinkSaga(action) {
  try {
    const res = yield call(updatePlanLink, action.payload);
    if (res?.type === 1) {
      yield put(updatePlanLinkSuccess(res.data));
      toast.success(res.message || "Plan link updated successfully!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Update link failed");
  } catch (error) {
    yield put(updatePlanLinkFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

function* deletePlanLinkSaga(action) {
  try {
    const res = yield call(deletePlanLink, action.payload);
    if (res?.type === 1) {
      yield put(deletePlanLinkSuccess(action.payload));
      toast.success(res.message || "Plan link deleted successfully!");
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Delete link failed");
  } catch (error) {
    yield put(deletePlanLinkFailure(error.message));
    toast.error(error.message);
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

function* readPlanLinkSaga(action) {
  try {
    const res = yield call(readPlanLink, action.payload);
    if (res?.type === 1) {
      yield put(readPlanLinkSuccess(res.data));
      if (action.callback) action.callback({ type: 1, data: res.data });
    } else throw new Error(res?.error || "Read link failed");
  } catch (error) {
    yield put(readPlanLinkFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}
// ✅ Watcher
export default function* planWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_PLAN_REQUEST, savePlanSaga);
  yield takeLatest(actionTypes.UPDATE_PLAN_REQUEST, updatePlanSaga);
  yield takeLatest(actionTypes.DELETE_PLAN_REQUEST, deletePlanSaga);
  yield takeLatest(actionTypes.READ_PLAN_REQUEST, readPlanSaga);

  yield takeEvery(actionTypes.SAVE_DAYPLAN_REQUEST, saveDayPlanSaga);
  yield takeEvery(actionTypes.UPDATE_DAYPLAN_REQUEST, updateDayPlanSaga);
  yield takeEvery(actionTypes.DELETE_DAYPLAN_REQUEST, deleteDayPlanSaga);
  yield takeEvery(actionTypes.READ_DAYPLAN_REQUEST, readDayPlanSaga);
  yield takeEvery(actionTypes.SAVE_DAYPLAN_DETAIL_REQUEST, saveDayPlanDetailSaga);
  yield takeEvery(actionTypes.UPDATE_DAYPLAN_DETAIL_REQUEST, updateDayPlanDetailSaga);
  yield takeEvery(actionTypes.DELETE_DAYPLAN_DETAIL_REQUEST, deleteDayPlanDetailSaga);
  yield takeLatest(actionTypes.READ_PLAN_CATEGORIES_REQUEST, readPlanCategoriesSaga);
  yield takeLatest(actionTypes.SAVE_PLAN_CATEGORY_REQUEST, savePlanCategorySaga);
  yield takeLatest(actionTypes.READ_TWG_PLANS_REQUEST, readTWGPlansSaga);

  yield takeLatest(actionTypes.SAVE_PLANLINK_REQUEST, savePlanLinkSaga);
  yield takeLatest(actionTypes.UPDATE_PLANLINK_REQUEST, updatePlanLinkSaga);
  yield takeLatest(actionTypes.DELETE_PLANLINK_REQUEST, deletePlanLinkSaga);
  yield takeLatest(actionTypes.READ_PLANLINK_REQUEST, readPlanLinkSaga);

}
